// extracted by css-extract-rspack-plugin
export default {"root":"yt5lGWGz9ozJQW8W","main":"byFwWNAY2m0egSaB","logo":"_Su5iySc1DUXljD3","title":"D7L_AnOk7wNmEWSW","description":"Tcvsycg2JJE6Pqd1","actions":"zox06effT2kSuEYm"};